import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import useRefreshToken from '../../hooks/useRefreshToken';
import useAuth from '../../hooks/useAuth';
import { Loading } from '../../common/index'

const PersistLogin = () => {
    const [isLoading, setIsLoading] = useState(true);
    const refresh = useRefreshToken();
    const { auth, persist } = useAuth();

    useEffect(() => {
        const verifyRefreshToken = async () => {
            try {
                await refresh();
            }
            catch (err) {
                console.error(err);
            }
            finally {
                setIsLoading(false);
            }
        }
        
        !auth?.token && persist ? verifyRefreshToken() : setIsLoading(false);
        
    }, [auth, persist, refresh])

    return (
        <>
            {!persist
                ? <Outlet />
                : isLoading
                    ? <Loading wrapperHeight="100vh" />
                    : <Outlet />
            }
        </>
    )
}

export default PersistLogin